<template>
    <FinancialInformationForm ref="fIForm" class="p-2 b-a-2 bg-white" :submit="submit" :user="user" />
</template>

<script>
import FinancialInformationForm from './../components/FinancialInformationForm'
import { mapActions } from 'vuex'

export default {
    name: 'Financial',

    components: {
        FinancialInformationForm,
    },

    props: {
        user: {
            default() {
            }
        }
    },

    methods: {
        ...mapActions({
            updateFinancial: 'user/updateFinancial',
            setShowLoading: 'loadingComponent/setShowLoading',
            setMsg: 'messageComponent/setMsg',
            resetMsg: 'messageComponent/resetMsg',
        }),
        submit() {
            this.setShowLoading()
            this.resetMsg()

            const data = {
                id: this.user.id,
                card_number: this.user.card_number,
                sheba_number: this.user.sheba_number ? 'IR' + this.user.sheba_number : '',
                account_owner_name: this.user.account_owner_name,
                account_number: this.user.account_number,
                bank_name: this.user.bank_name,
            }

            this.updateFinancial(data).then(() => {
                this.setShowLoading(false)
                this.setMsg({
                    content: this.$t('user.updated'),
                    type: 'success'
                })
            })
            .catch(error => {
                if (error.data) {
                    this.$refs.fIForm.$refs.form.setErrors(error.data)
                }
                this.setShowLoading(false)
                this.setMsg({
                    content: this.$t('tags.' + error.tag),
                    type: 'danger'
                })
            })
        }
    }
}
</script>